module.exports = __webpack_public_path__ + "images/you-missed-it-bg.jpg";